import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { NavProfileListComponent } from './nav-profile-list.component';
import { AvatarModule } from '../../../messaging/avatar/avatar.module';

@NgModule({
  declarations: [NavProfileListComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatMenuModule,
    MatIconModule,
    AvatarModule,
  ],
  exports: [NavProfileListComponent],
})
export class NavProfileListModule {}
